import { Scene as ThreeScene } from 'three';
import { appMixin } from '../utils/appMixin';

export class Scene extends appMixin(ThreeScene) {
  onAttach() {
    // this.background = app.core.loader.getTexture('arena');
  }

  sceneLoaded = () => {
    // scene.traverse((m) => {
    // 	if (m.material) {
    // 		m.material.envMapIntensity = 0.7;
    // 	}
    // });
    // this.indexes.syncronize(scene);
    // this.screens.syncronize();
    // this.clock.syncronize(scene);
    // this.dial.syncronize(scene);
    // this.add(this.indexes);
    // this.add(this.screens);
    // this.add(this.clock);
    // this.add(this.dial);
    // this.add(new AmbientLight(0xffffff, 0.5));
    // this.clickables = this.screens.instances.map((instance) => instance._clickablePlane);
    // state.emit(EVENTS.LOADED);
  };
}
